import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouter } from 'next/router';
import {
  BreadcrumbsCurrent,
  BreadcrumbsItem,
  BreadcrumbsLink,
  BreadcrumbsList
} from './styled';

export interface BreadcrumbI {
  stat: string;
  link: string;
  text: string;
}

interface BreadcrumbsProps {
  breadcrumbs: BreadcrumbI[];
  cypress: string;
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
  breadcrumbs,
  cypress
}) => {
  const { t } = useTranslation();
  const { asPath } = useRouter();
  const currentPath = asPath?.split('#')[0];

  return (
    <BreadcrumbsList data-cy={cypress}>
      {breadcrumbs.map(({ stat, link, text }, index) => {
        const isCurrentPage =
          index === breadcrumbs.length - 1 && link === currentPath;

        return (
          <BreadcrumbsItem key={link + text}>
            {isCurrentPage ? (
              <BreadcrumbsCurrent aria-current="page" data-cy={stat}>
                {t(text)}
              </BreadcrumbsCurrent>
            ) : (
              <BreadcrumbsLink href={link} data-stat={stat} data-cy={stat}>
                {t(text)}
              </BreadcrumbsLink>
            )}
          </BreadcrumbsItem>
        );
      })}
    </BreadcrumbsList>
  );
};
